import {
  Message,
  MessageBox
} from 'element-ui'

function handleError(data) {
  Message({
    // 格式待定
    message: data.errMsg,
    type: 'warning',
    duration: 10000,
    showClose: true
  })
}

function handleException({
  status,
  message,
  stack
}) {
  MessageBox({
    title: message || '系统提示',
    message: `<div style='max-height: 250px; overflow: auto;'>${stack}</div>`,
    type: 'error',
    showClose: true,
    dangerouslyUseHTMLString: true,
    callback(action, instance) {}
  })
}

// 全局错误处理
export default {
  options: {
    // 全局错误处理器
    errorHandle(error) {
      if (error.response == null) {
        handleException({
          status: 500,
          message: error.message,
          stack: error.stack
        })
      } else if (error.response.data == null || typeof error.response.data !== 'object') {
        handleException({
          status: error.response.status,
          message: error.message,
          stack: error.stack
        })
      } else if (error.config.handleError !== false) {
        handleError(error.response.data)
      }
    }
  },
  install(requestInterceptor, responseInterceptor, opts = {}) {
    opts = Object.assign({}, this.options, opts)
    responseInterceptor.use(response => response, error => {
      if (error.config && error.config.errorHandle !== false) {
        opts.errorHandle(error)
      }
      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/packages/plugins/src/axios/src/interceptor/src/errorHandle.js